import React, { createContext, useMemo } from "react";
import { LoadingOverlay } from "@mantine/core";
import { useMessageTemplates } from "./StrapiCMSApiService";
import { EventTypesContextType } from "./types";

const EventTypesContext = createContext<EventTypesContextType>({
  templates: [],
});

const EventTypesProvider: React.FC = ({ children }) => {
  const { isLoading, data } = useMessageTemplates();

  const value = useMemo(
    () => ({
      templates: data?.data || [],
    }),
    [data?.data]
  );

  if (isLoading) {
    return <LoadingOverlay visible />;
  }

  return (
    <EventTypesContext.Provider value={value}>
      {children}
    </EventTypesContext.Provider>
  );
};

export { EventTypesProvider, EventTypesContext };
